// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBar-cls1_BCi","cls2":"SearchBar-cls2_Fmb SearchBar-cls1_BCi"};